import React from 'react';

import { Button } from '@flywire/headlessui-tailwindcss';
import PropTypes from 'prop-types';

import { formatAmount } from 'utils/money';

import { useOfferContext } from '../../Offer';

function Actions({ onSelect }: { onSelect?: (id: string) => void }) {
  const { id, i18n, name, price, fee, currency } = useOfferContext();
  const { value: priceValue } = price;
  const feeValue = fee?.value || 0;
  const hasFee = feeValue > 0;
  const priceWithFormat = formatAmount(priceValue, currency);
  const feeWithFormat = formatAmount(feeValue, currency);
  const a11yMessage = [
    `${i18n.t('offers.select')}: ${name}. `,
    `${i18n.t('paymentTracking.amount_to_send')}: ${priceWithFormat}`,
    ...[
      hasFee
        ? [
            `, ${i18n
              .t('offers.includes_fee', { fee: feeWithFormat })
              .toLowerCase()}.`,
          ]
        : [],
    ],
  ].join('');

  function handleOnClick() {
    onSelect?.(id);
  }

  return (
    <div className="Offer-actions">
      <Button
        tone="primary"
        className="w-full md:w-32"
        onClick={handleOnClick}
        data-testid="offer-select"
        aria-label={a11yMessage}
      >
        <span className="capitalize">{i18n.t('offers.select')}</span>
      </Button>
    </div>
  );
}

Actions.displayName = 'Actions';
Actions.propTypes = {
  onSelect: PropTypes.func,
};

export { Actions };
